import { Component, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { SessionStoreRepository } from '../../repositories/session.repository';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { TranslocoDirective } from "@jsverse/transloco";

@Component({
    selector: 'web-patient-footer',
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss',
    imports: [CommonModule, TranslocoDirective, NgOptimizedImage]
})
export class FooterComponent {
  appVersion = environment.appVersion;
  private readonly sessionService = inject(SessionStoreRepository)
  private readonly router = inject(Router);

  public readonly isPatient$: Observable<boolean> = this.sessionService.isPatient$;

  navigateToUserPage(fragment: string): void {
        this.isPatient$.subscribe({
            next: value => {
                if (value) {
                    this.router.navigate(["/profile"], { fragment: fragment });
                } else {
                    this.router.navigate(["/clinic"]);
                }
            }
        })
    }
}
